<template>
  <a-popconfirm
    class="append-to-body"
    overlayClassName="table-column-set"
    placement="bottomLeft"
    ok-text="确认"
    cancel-text="取消"
    @confirm.stop="confirms"
  >
    <!-- v-model:visible="popconfirmVisible" -->

    <template #icon><span class="hide"></span></template>
    <template #title>
      <div class="set-column">
        <h4>列表显示设置</h4>
        <!-- <ant-icon type="CloseOutlined" @click="cancel"></ant-icon> -->
      </div>
      <a-checkbox style="width: 150px" :checked="true" disabled>序号</a-checkbox>
      <a-tree
        checkable
        defaultExpandAll
        class="not-switcher-icon"
        :selectable="false"
        v-model:checkedKeys="columnsFillter"
        :tree-data="columns"
      >
        <!-- <template #switcherIcon><span class="hide"></span></template> -->
      </a-tree>
    </template>
    <a-button type="link" class="setting-btn">
      <ant-icon type="SettingOutlined"></ant-icon>
    </a-button>
  </a-popconfirm>
</template>

<script lang="ts" setup>
import { onMounted, ref, unref } from "vue";
import { VxeTableInstance } from "vxe-table";
import { TableListService, TitleParamReq } from "./table-list.service";
const props = withDefaults(
  defineProps<{
    columns: Array<any>;
    xTable: VxeTableInstance | null;
    tabeleBizCode?: string;
  }>(),
  {
    columns: () => [],
    xTable: null,
    tabeleBizCode: "",
  }
);
const emits = defineEmits(["changeColumns"]);
let columnsFillter = ref<string[]>([]);
let saveValue: Array<TitleParamReq> = [];
const { run: getColumns, data: columnsData } = TableListService.useGetColumnsApi();
const { run: changeColumns } = TableListService.useChangeColumnsApi();
const confirms = () => {
  saveValue = [];

  props.columns.map((e) => {
    !e["key"] && (e["key"] = e["dataIndex"]);

    if (e["children"] && e["children"].length > 0) {
      e["isShow"] = false;
      e["children"].map((v) => {
        !v["key"] && (v["key"] = v["dataIndex"]);
        v["isShow"] = columnsFillter.value.includes((v.key ? v.key : v.dataIndex) as string);
        v["isShow"] && (e["isShow"] = true);
        v["isShow"] &&
          saveValue.push({
            attributeValue: v.key,
            name: v["title"],
          });
      });
    } else {
      e["isShow"] = columnsFillter.value.includes((e.key ? e.key : e.dataIndex) as string);
      e["isShow"] &&
        saveValue.push({
          attributeValue: e.key,
          name: e["title"],
        });
    }
  });

  saveColumns();
  (props.xTable as any).refreshColumn();
  emits("changeColumns", saveValue);
};
const loadColumnFillter = () => {
  let storageColumns: any = null;
  if (unref(columnsData) && unref(columnsData)?.titleParamReqs) {
    // // console.log(
    //   "🚀 ~ file: editableCell.vue ~ line 80 ~ loadColumnFillter ~ columnsData",
    //   unref(columnsData)
    // );
    storageColumns = [];
    unref(columnsData)?.titleParamReqs?.map((c) => {
      storageColumns.push(c.attributeValue);
    });
  }
  if (!storageColumns) {
    props.columns.map((e) => {
      !e["key"] && (e["key"] = e["dataIndex"]);
      if (e["children"] && e["children"].length > 0) {
        e["children"].map((v) => {
          !v["key"] && (v["key"] = v["dataIndex"]);

          !(v["isShow"] === false) &&
            columnsFillter.value.push((v.key ? v.key : v.dataIndex) as string);
          !(v["isShow"] === false) &&
            saveValue.push({
              attributeValue: v.key,
              name: v["title"],
            });
        });
      } else {
        !(e["isShow"] === false) &&
          columnsFillter.value.push((e.key ? e.key : e.dataIndex) as string);
        !(e["isShow"] === false) &&
          saveValue.push({
            attributeValue: e.key,
            name: e["title"],
          });
      }
    });
  } else {
    columnsFillter.value = storageColumns;
    props.columns.map((e) => {
      !e["key"] && (e["key"] = e["dataIndex"]);
      if (e["children"] && e["children"].length > 0) {
        e["isShow"] = false;
        e["children"].map((v) => {
          !v["key"] && (v["key"] = v["dataIndex"]);
          v["isShow"] = columnsFillter.value.includes((v.key ? v.key : v.dataIndex) as string);
          v["isShow"] && (e["isShow"] = true);
          v["isShow"] &&
            saveValue.push({
              attributeValue: v.key,
              name: v["title"],
            });
        });
      } else {
        e["isShow"] = columnsFillter.value.includes((e.key ? e.key : e.dataIndex) as string);
        e["isShow"] &&
          saveValue.push({
            attributeValue: e.key,
            name: e["title"],
          });
      }
    });
  }

  emits("changeColumns", saveValue);
};
const saveColumns = () => {
  props.tabeleBizCode != "" &&
    changeColumns({
      bizType: props.tabeleBizCode,
      titleParamReqs: saveValue,
    });
};
onMounted(async () => {
  if (props.tabeleBizCode != "") {
    await getColumns({ bizType: props.tabeleBizCode });
  }
  loadColumnFillter();
  // console.log(props.columns, columnsFillter);
});
</script>
<style lang="less">
.table-column-set {
  width: 200px;
  h4 {
    margin-bottom: 5px;
  }
  .ant-popover-message-title {
    padding: 0;
    max-height: 540px;
    overflow-y: auto;
    overflow-x: hidden;
    width: 185px;
  }
  .ant-popover-message-title::-webkit-scrollbar {
    width: 6px;
    height: 8px;
  }

  .ant-popover-message-title::-webkit-scrollbar-track {
    background-color: transparent;
  }

  .ant-popover-message-title::-webkit-scrollbar-thumb {
    // background: rgba(0, 0, 0, 0.6);
    background-color: rgb(144 147 153 / 30%);
    border-radius: 2px;
    box-shadow: inset 0 0 6px rgb(0 0 0 / 20%);
  }

  .ant-popover-message-title::-webkit-scrollbar-thumb:hover {
    background-color: #cbcbcb;
  }

  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin: 0;
  }
  .set-column {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    margin-bottom: 5px;
    align-items: baseline;
  }
  .ant-tree.not-switcher-icon .ant-tree-switcher {
    position: relative;
    display: none;
  }
  .ant-tree .ant-tree-node-content-wrapper .ant-tree-title {
    white-space: nowrap;
    max-width: 120px;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.mw200.ant-select-multiple .ant-select-selection-item-content {
  max-width: 80px;
}
.setting-btn {
  font-size: 19px;
  padding: 5px;
  //   margin-top: -8px;
  color: #83858a;
}
</style>
